export const setItemInLocalStorage = (key: any , value: any) =>
  localStorage.setItem(key, value);

export const getItemFromLocalStorage = (key: any) => localStorage.getItem(key);